var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSplit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#table--split_svg__clip0_61530_7378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 2.25H3.75a1.5 1.5 0 00-1.5 1.5v16.5a1.5 1.5 0 001.5 1.5h16.5a1.5 1.5 0 001.5-1.5V3.75a1.5 1.5 0 00-1.5-1.5zm0 1.5v3H3.75v-3h16.5zm-7.5 4.5h7.5v5.25h-7.5V8.25zm-1.5 5.25h-7.5V8.25h7.5v5.25zM3.75 15h7.5v5.25h-7.5V15zm9 5.25V15h7.5v5.25h-7.5z",
    fill: "#45464F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "table--split_svg__clip0_61530_7378"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTableSplit;